enum SplitDialogFields {
	MODE = 'mode',
	MODE_LAST = "mode_last",
	MODE_FIRST = "mode_first",
	MODE_LIST = "mode_list",
	PAGERANGE = 'pagerange',
	PAGENUMBER = 'pagenumber'
}

export default SplitDialogFields;